import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Cgu() {
  return (
    <>
      <Helmet>
        <title>Conditions Générales d'Utilisation | LMFP Photography</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.lmfp-photography.com/cgu" />
        <meta name="description" content="Consultez les Conditions Générales d'Utilisation du site LMFP Photography." />
      </Helmet>

      <div className="min-h-screen bg-gray-900 text-white px-4 py-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden">
            <div className="px-8 pt-10 pb-6 border-b border-white/10">
              <p className="uppercase tracking-[0.3em] text-xs text-gray-400 mb-3">
                LMFP Photography
              </p>
              <h1 className="text-3xl md:text-4xl font-bold mb-3">
                Conditions Générales d'Utilisation
              </h1>
              <p className="text-gray-400 text-sm md:text-base max-w-2xl">
                Les présentes Conditions Générales d'Utilisation définissent les
                modalités d'accès et d'utilisation du site LMFP Photography.
              </p>
            </div>

            <div className="px-8 py-8 space-y-8 text-sm md:text-base text-gray-200 leading-7">
              <section>
                <h2 className="text-xl font-semibold text-white mb-3">1. Objet</h2>
                <p>
                  Les présentes Conditions Générales d'Utilisation (CGU) ont pour
                  objet de définir les modalités d'accès et d'utilisation du site
                  LMFP Photography.
                </p>
                <p className="mt-3">
                  En créant un compte ou en utilisant le site, l'utilisateur
                  accepte les présentes CGU.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  2. Éditeur du site
                </h2>
                <p>Le site LMFP Photography est édité par : Schroeders Geoffrey</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>Nom / activité : LMFP Photography</li>
                  <li>Responsable : Schroeders Geoffrey</li>
                  <li>Email de contact : lmfp.photography@gmail.com</li>
                  <li>Pays : Belgique</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  3. Services proposés
                </h2>
                <p>Le site permet notamment :</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>la création d'un compte utilisateur ;</li>
                  <li>l'accès à un espace personnel ;</li>
                  <li>la consultation de contenus liés à la photographie ;</li>
                  <li>
                    la mise en relation ou la collaboration entre visiteurs,
                    mannequins, photographes et organisateurs.
                  </li>
                </ul>
                <p className="mt-3">
                  LMFP Photography se réserve le droit de modifier, suspendre ou
                  interrompre tout ou partie des services à tout moment.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  4. Création de compte
                </h2>
                <p>
                  Pour accéder à certaines fonctionnalités, l'utilisateur doit
                  créer un compte en fournissant des informations exactes,
                  complètes et à jour.
                </p>
                <p className="mt-3">
                  L'utilisateur est responsable des informations communiquées lors
                  de son inscription ainsi que de la confidentialité de ses
                  identifiants de connexion.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  5. Obligations de l'utilisateur
                </h2>
                <p>L'utilisateur s'engage à :</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>ne pas fournir de fausses informations ;</li>
                  <li>ne pas porter atteinte au bon fonctionnement du site ;</li>
                  <li>
                    ne pas publier ou transmettre de contenu illicite, injurieux,
                    diffamatoire, haineux, violent ou portant atteinte aux droits
                    d'autrui ;
                  </li>
                  <li>
                    respecter les lois applicables et les droits des autres
                    utilisateurs.
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  6. Suspension ou suppression de compte
                </h2>
                <p>
                  LMFP Photography se réserve le droit de suspendre ou supprimer
                  un compte utilisateur en cas de non-respect des présentes CGU,
                  d'usage frauduleux ou de comportement abusif.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  7. Propriété intellectuelle
                </h2>
                <p>
                  Les contenus présents sur le site, notamment les textes,
                  visuels, photographies, logos, éléments graphiques et structure
                  du site, sont protégés par le droit de la propriété
                  intellectuelle.
                </p>
                <p className="mt-3">
                  Sauf autorisation écrite préalable, toute reproduction,
                  représentation, diffusion ou exploitation, totale ou partielle,
                  est interdite.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  8. Responsabilité
                </h2>
                <p>
                  LMFP Photography met en œuvre des moyens raisonnables pour
                  assurer l'accessibilité et le bon fonctionnement du site, sans
                  garantir une disponibilité continue ni l'absence totale
                  d'erreurs.
                </p>
                <p className="mt-3">
                  L'éditeur ne pourra être tenu responsable des dommages
                  indirects, pertes de données, interruptions, bugs ou
                  incompatibilités techniques liés à l'utilisation du site.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  9. Données personnelles
                </h2>
                <p>
                  Les données personnelles collectées dans le cadre de
                  l'utilisation du site sont traitées conformément à la{" "}
                  <Link
                    to="/confidentialite"
                    className="text-white underline hover:text-gray-300"
                  >
                    Politique de confidentialité
                  </Link>
                  .
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  10. Modification des CGU
                </h2>
                <p>
                  LMFP Photography peut modifier les présentes CGU à tout moment.
                </p>
                <p className="mt-3">
                  La version applicable est celle publiée sur le site à la date de
                  consultation. En cas de modification importante, les
                  utilisateurs pourront être informés par le site ou par email.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">
                  11. Droit applicable
                </h2>
                <p>Les présentes CGU sont soumises au droit belge.</p>
                <p className="mt-3">
                  En cas de litige, les parties rechercheront d'abord une solution
                  amiable. À défaut, les juridictions compétentes seront celles
                  déterminées par le droit applicable.
                </p>
              </section>

              <div className="pt-4 border-t border-white/10 space-y-4">
                <p className="text-xs text-gray-500 text-center">
                  Site réalisé par Schroeders Benjamin
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/register"
                    className="inline-block px-6 py-3 rounded-xl bg-white text-black font-semibold hover:bg-gray-200 transition text-center"
                  >
                    Retour à l'inscription
                  </Link>
                  <Link
                    to="/confidentialite"
                    className="inline-block px-6 py-3 rounded-xl border border-white/15 text-white hover:bg-white/10 transition text-center"
                  >
                    Voir la politique de confidentialité
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cgu;